import { HttpClient } from '@angular/common/http';
import { HostListener, Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from "../../environments/environment"
import { UserInfoService } from './user-info.service';

@Injectable({
  providedIn: 'root'
})
export class FMSModulesService {

  modules = [
    {code: "expman", name: "Expense Manager"},
    {code: "budget" , name:"Budget"},
    {code: "book" , name:"Book"}
  ] 

  private subs! : Subscription;

  constructor(private userInfoService : UserInfoService,private http : HttpClient) {
    this.subs = new Subscription();
    this.subs.add(this.userInfoService.getCurrentModuleChangeSubs().subscribe({next : (module:any) => {
      this.onModuleChange();
    }}))
  }

  getModuleName(moduleCode : string) : string{
    const fmsmodule = this.modules.find(o => o.code==moduleCode);
    if(fmsmodule) {
      return fmsmodule.name;
    }
    return "";
  }

  onModuleChange() {
    const companyCode = this.userInfoService.getCurrentCompany();
    const module = this.userInfoService.getCurrentModule();
    if(companyCode && module) {
      this.regenToken(companyCode,module).subscribe({next : (res : any) => {
        if(res.status==200) {
          const token = res.body?.token
          //this.userInfoService.setToken(token);
        }
      },error : (err) => {

      }})
    }
  }

  regenToken(companyCode : string,moduleCode : string) {
    const body = {companyCode : companyCode,module : moduleCode};
    return this.http.post(environment.API_URL+"/api/regen-token",body,{headers : {},observe : "response"});
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event : any) {
    this.subs.unsubscribe();
  }
}
